/* Auto-generado por scripts/emit-pwa-build-id.js (prebuild/prestart) — no editar a mano */
export const PWA_BUILD_ID = "pwa-1793815965677";
